module.exports = {
	baseUrl : '/',
	globalUrl : 'https://www.covert.jp/',
	dist : 'dist/production',
	pwa : true
}